import request from '../services/request';

export function search(data) {
  return request({
    url: `/kiosk/search`,
    method: 'POST',
    data,
  });
}

export function searchKiosks(data, page) {
  return request({
    url: `/kiosk/search?page=${page}`,
    method: 'POST',
    data,
  });
}

export function storeKiosk(data) {
  return request({
    url: `/kiosk`,
    method: 'POST',
    data,
  });
}

export function statusKiosk(id, data) {
  return request({
    url: `/kiosk/${id}/status`,
    method: 'PUT',
    data,
  });
}

export function updateKiosk(id, data) {
  return request({
    url: `/kiosk/${id}`,
    method: 'PUT',
    data,
  });
}

export function indexKiosk() {
  return request({
    url: `/kiosk`,
    method: 'GET',
  });
}

export function getKioskById(id, data) {
  return request({
    url: `/kiosk/${id}`,
    method: 'GET',
    data,
  });
}

export function exportFile(data, configs) {
  return request({
    url: `/kiosk/export`,
    method: 'POST',
    responseType: 'blob',
    data,
    ...configs,
  });
}

export function deleteKiosk(id) {
  return request({
    url: `/kiosk/${id}`,
    method: 'DELETE',
  });
}

export function getAnalyticsKiosk(data) {
  return request({
    url: `/kiosk/dashboard/analytics`,
    method: 'POST',
    data,
  });
}

// -------------- Catalogos para combobox ------------------------

export function catalogCompanies() {
  return request({
    url: `/kiosk/catalog/companies`,
    method: 'GET',
  });
}

export function catalogLocations(data) {
  return request({
    url: `/kiosk/catalog/locations`,
    method: 'POST',
    data,
  });
}

export function catalogBuildings(data) {
  return request({
    url: `/kiosk/catalog/building`,
    method: 'POST',
    data,
  });
}

export function catalogZones(data) {
  return request({
    url: `/kiosk/catalog/zone`,
    method: 'POST',
    data,
  });
}

export function catalogAccessTypes() {
  return request({
    url: `/kiosk/catalog/access-type`,
    method: 'GET',
  });
}

export function resetKiosk(id) {
  return request({
    url: `/kiosk/${id}/reset`,
    method: 'PUT',
  });
}
